"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RelationalNodeDependencies = void 0;
var _dependenciesNodeGenerated = require("./dependenciesNode.generated.js");
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var RelationalNodeDependencies = exports.RelationalNodeDependencies = {
  NodeDependencies: _dependenciesNodeGenerated.NodeDependencies,
  createRelationalNode: _factoriesAny.createRelationalNode
};